export default __webpack_public_path__ + "static/media/template_04.54aa0df8.jpg";